import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {

    static get API_URL(): string {
        return environment.appUrl + 'api/';
    }

    static get APP_URL(): string {
        return environment.appUrl + 'admin/';
    }

    static get LOGIN(): string {
        return AppUrl.APP_URL + 'login';
    }


    static get SELF(): string {
        return AppUrl.APP_URL + 'self';
    }

    static UPDATE_SELF(): string {
        return AppUrl.API_URL + 'update-self';
    }

    static LOGOUT(): string {
        return AppUrl.API_URL + 'logout';
    }
    static ALL_CONTACT(): string {
        return AppUrl.APP_URL + 'contact-us';
    }

    // Blogs
    static BLOGS(): string {
        return AppUrl.APP_URL + 'blogs';
    }

    static BLOG(id: number | string): string {
        return AppUrl.APP_URL + 'blogs/' + id;
    }

    static BLOG_UPLOAD_IMAGE(): string {
        return AppUrl.APP_URL + 'blogs/upload-image';
    }

    // Blog Categories
    static BLOG_CATEGORIES(): string {
        return AppUrl.APP_URL + 'blog-categories';
    }

    static BLOG_CATEGORY(id: number | string): string {
        return AppUrl.APP_URL + 'blog-categories/' + id;
    }

    // Blog Tags
    static BLOG_TAGS(): string {
        return AppUrl.APP_URL + 'blog-tags';
    }

    static BLOG_TAG(id: number | string): string {
        return AppUrl.APP_URL + 'blog-tags/' + id;
    }
}
